import { Button } from '@studio/design-system/button';
import type { ReactElement } from 'react';
import { Notifications } from './notifications.jsx';
import type { Wiring } from './wiring.js';

/** @internal */
export const ActionTray = (wiring: Wiring): ReactElement => {
  const {
    handleStopTrackingSelectedSubject,
    hasAnnotations,
    hasAssignment,
    isConnected,
    wantsTracking
  } = wiring;

  return (
    <div className='flex h-full w-full items-end justify-center'>
      <div className='absolute z-30 mb-40 p-8'>
        {
          <>
            <Notifications {...wiring} />

            {!!hasAssignment && !!isConnected && !!hasAnnotations && !!wantsTracking && (
              <Button
                className='bg-error p-8 hover:enabled:bg-error-highlight'
                onClick={(): void => {
                  handleStopTrackingSelectedSubject();
                }}
              >
                Stop Tracking
              </Button>
            )}
          </>
        }
      </div>
    </div>
  );
};
